// extracted by mini-css-extract-plugin
module.exports = {"content":"_257L5","video":"_1gM-5","video-text":"Ezwm9","text-one":"_22TmC","text-two":"_2jfY5","red":"_1ECfd"};